import { BaseControl } from './base';
import { FormFieldSerializedValue } from '../index';

export class CheckboxControl extends BaseControl {
  unserializeValue(): any {
    const truthyOptions = [1, '1', 'true', true];

    return truthyOptions.some(opt => opt === this.field.value);
  }

  serializeValue(formControlValue: any): FormFieldSerializedValue {
    return formControlValue === true;
  }
}
